import React from "react";

const Terms = () => {
    return <div>i</div>
};
export default Terms;